import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import parse from "html-react-parser";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    padding: 0,
    minHeight: 20,
    "& .image": {
      margin: 0,
      "& img": {
        maxWidth: "100%",
      },
    },
  },
}));

interface TextEditorViewerProps {
  value: string;
  className?: string;
}

export const TextEditorViewer = ({
  value,
  className,
}: TextEditorViewerProps) => {
  const classes = useStyles();
  return (
    <div className={[classes.container, className].join(" ")}>
      {!!value && parse(value)}
    </div>
  );
};

TextEditorViewer.defaultProps = {
  className: "",
};
